<ion-grid>
  <ion-row>
    <ion-col *ngIf="avtaler">
      <ion-item
        class="check ion-margin-top"
        lines="none"
        *ngFor="let paaslag of paaslagList"
      >
        <ion-checkbox
          mode="md"
          (ionChange)="toggleShowPaaslag(paaslag)"
          checked="{{ paaslag.active === true }}"
          name="showPaaslag"
          id="showPaaslag"
          labelPlacement="start"
        >
          Inkluder mitt påslag: {{ paaslag.paaslag }} øre/kWh
        </ion-checkbox>
      </ion-item>
    </ion-col>
  </ion-row>
  <ion-row>
    <table width="100%">
      <thead>
        <tr>
          <th class="average">Dato</th>
          <th class="average">Døgnpris {{ selectedArea.omraade }}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="bold">Gjennomsnitt</td>
          <td class="bold">{{ averagePrice.toFixed(2) }} øre/kWh</td>
        </tr>
        <tr *ngFor="let day of tableData" class="table-row">
          <td [ngClass]="{ highest: day.isHighest, lowest: day.isLowest }">
            {{
              day.date.toLocaleDateString('nb-NO', {
                day: 'numeric',
                month: 'long'
              })
            }}
          </td>
          <td [ngClass]="{ highest: day.isHighest, lowest: day.isLowest }">
            {{ day.price.toFixed(2) }} øre/kWh
          </td>
        </tr>
      </tbody>
    </table>
  </ion-row>
</ion-grid>
